import { safeSetTimeout } from "@-/dev.improve.haniverse.lib.scheduler";

/** Coalesce hints without dropping a change that arrives during an in-flight check. */
export function createBackgroundSyncTask({
  delayMs = 1000,
  onError,
  run,
}: {
  delayMs?: number;
  onError: (error: unknown) => void;
  run: () => Promise<unknown>;
}) {
  let disposed = false;
  let running = false;
  let requested = false;
  let timer: ReturnType<typeof setTimeout> | undefined;

  const request = () => {
    if (disposed) {
      return;
    }
    requested = true;
    if (running || timer !== undefined) {
      return;
    }
    timer = safeSetTimeout(
      () => {
        timer = undefined;
        requested = false;
        running = true;
        void Promise.resolve()
          .then(() => (disposed ? undefined : run()))
          .catch((error: unknown) => {
            if (!disposed) {
              onError(error);
            }
          })
          .finally(() => {
            running = false;
            if (requested) {
              request();
            }
          });
      },
      delayMs,
      "actor-background-sync",
    );
  };

  return {
    cancel: () => {
      disposed = true;
      if (timer !== undefined) {
        clearTimeout(timer);
      }
    },
    request,
  };
}
